// /* global defaultConfig  */
import React from 'react'
import os from 'os'
import swal from 'sweetalert2'
import { isEmpty, startCase, toLower } from 'lodash'
import moment from 'moment'
import hash from 'object-hash'
import {  getCurrencyRate } from 'currencies-exchange-rates'
// Functions can be resued
// import config from 'config'
import { ServerConfig } from 'staticConfig.js'

//logger(process.cwd())
// console.log('NODE_CONFIG_DIR: ' + JSON.stringify(process.env))
// const { sameServer, protocol, host, port } = config.get('dataServer')
// const ServerConfig = config.get('ServerConfig')
// console.log({ sameServer, protocol, host, port })

/***
  Usage: construct API server URI based upon the configuration for client side
  Note:  defaultConfig is coming from /config/default.js which will be loaded directly in index.html
         so it can control how the client reach to the API server
*/

// export const getDataServer = () => {
//   const {
//     dataServer: { sameServer, protocol, host, port }
//   } = ServerConfig
//   logger(ServerConfig)
//   const dynamicHostname = window.location.host.substr(0, window.location.host.indexOf(':'))
//   let actualHost
//   if (sameServer) {
//     actualHost = dynamicHostname
//   } else {
//     actualHost = host
//   }
//   return protocol + '://' + actualHost + ':' + port
// }

export const getDataServer = () => {
  let config
  // if (process.env.NODE_ENV !== 'production') {
  //   config = ServerConfig
  // } else {
  //   config = defaultConfig
  // }
  config = ServerConfig()
  // console.log('Utility - getDataServer:' + JSON.stringify(config))
  const {
    dataServer: { sameServer, protocol, host, port },
  } = config
  // if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_CONSOLE_LOG === 'enable') {
  //   console.log({ defaultConfig })
  // }
  // get the hostname of web server
  const tempString = window.location.host
  const dynamicHostname = tempString.substr(0, tempString.indexOf(':') === -1 ? tempString.length : tempString.indexOf(':'))
  //logger(`[utility][getDataServer]: `, window.location.host)
  //logger(`[utility][getDataServer]: `, config)
  let actualHost
  if (sameServer) {
    // resolved host
    actualHost = dynamicHostname
  } else {
    // configured host
    actualHost = host
  }
  return protocol + '://' + actualHost + ':' + port
}

/***
  Usage: universal logger for client side
  Args:  
    context:  module or function name of the caller
    message:  to be recorded
    toServer: true or false to decide if the message will be pushed up to the server
  Note: the ENV variables will only take effective after reloading
*/
export const logger = (context, message, toServer) => {
  //local logging
  // process.env.REACT_APP_CONSOLE_LOG === 'enable'
  const { logging } = ServerConfig()

  if (process.env.NODE_ENV === 'development' || logging) {
    console.log(context, message)
  }
  //remote logging
  if (toServer && logging) {
    fetch(getDataServer() + `/bugreport`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        'Content-type': 'application/json',
        // authorization: getToken()
      }),
      body: JSON.stringify({ context, message }),
    }).catch((e) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log(context, e)
      }
    })
  }
}

export const getToken = () => {
  const token = localStorage.getItem('token')
  return token ? `Bearer ${token}` : ''
}
export const noError = (state) => {
  console.log({ state })
  /*
   1. assume no error, if found one, it returns false
   2. slice on initial array, so it won't be modified later inside the reducer
   3. splice inside reducer is to exist early, it cuts out any reminder element once a false condisiton is reached
   4. this will work best with a structure of  
      dataState: {
        state: error|success|required
        message:{
          error: ''
          success: ''
          required: ''
        }
      }
  */
  return Object.keys(state)
    .slice(0)
    .reduce((agg, keyOfState, index, originalArray) => {
      if (Array.isArray(state[keyOfState])) {
        console.log(state[keyOfState])
        return agg && noError(state[keyOfState])
      } else {
        if (typeof state[keyOfState] === 'object') {
          return agg && true
        } else {
          //只是在不空且不明确等于success时 标为错误
          // if (!isEmpty(state[keyOfState]) && state[keyOfState] !== 'success') {
          //   console.log(isEmpty(state[keyOfState]), state[keyOfState]) // error report
          //   return false
          // }
          console.log(keyOfState)
          switch (state[keyOfState]) {
            case 'error':
              swal.fire({ title: 'Validataion Error', html: `There is an input error in field of ${keyOfState}.`, type: 'warning' })
              originalArray.splice(index)
              return false
            case 'required':
              swal.fire({ title: 'Validataion Error', html: `${keyOfState} is required but not set.`, type: 'warning' })
              originalArray.splice(index)
              return false
            default:
              return agg && true
          }
        }
      }
    }, true)
}
/*
  This should be used to replace all the similar process for any save function of forms
*/
export const handleResponseOfSaving = (response, refetch) => {
  if (response.ok) {
    swal.fire({ title: 'Saving Data', html: 'This record has beend saved', type: 'success' })
    if (refetch) refetch()
  } else {
    response.json().then((error) => swal.fire({ title: 'Saving Data', html: error, type: 'error' }))
  }
}
Number.prototype.toMoney = function () {
  var integer = this.toString().split('.')[0]
  var decimal = this.getDecimal()

  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  if (!decimal || !decimal.length) {
    decimal = '00'
  } else if (decimal.length === 1) {
    decimal += '0'
  } else if (decimal.length > 2) {
    decimal = decimal.substr(0, 2)
  }
  return integer + '.' + decimal
  //return '$' + integer + '.' + decimal
}

Number.prototype.getDecimal = function () {
  var n = Math.abs(this)
  var dec = n - Math.floor(n)
  dec = (Math.round(dec * 100) / 100).toString()

  if (dec.split('.').length) {
    return dec.split('.')[1]
  } else return ''
}

// export const floatFormat = num => {
//   return `${num.toLocaleString('en-US', { maximumFractionDigits: 2 })}`
// }

export const floatFormat = (num) => {
  if (isNaN(num)) return
  switch (typeof num) {
    case 'undefined':
      return ''
    case 'number':
      return num.toMoney()
    default:
      if (verifyNumber(num)) {
        return Number(num).toMoney()
      } else {
        return num
      }
  }
}
export const verifyEmail = (value) => {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (emailRex.test(value)) {
    return true
  }
  return false
}
// function that verifies if a string has a given length or not
export const verifyLength = (value, length) => value.length === length

// function that verifies if a string has a minimum length or not
export const verifyMinLength = (value, length) => value.length >= length

// function that verifies if a string has a maximum length or not
export const verifyMaxLength = (value, length) => {
  console.log(value.length, length)
  return value.length <= length
}

// function that verifies if two strings are equal
export const compare = (string1, string2) => string1 === string2

// function that verifies if value contains only numbers
export const verifyNumber = (value) => {
  var numberRex = new RegExp('^[0-9.]+$')
  if (numberRex.test(value)) {
    return true
  }
  return false
}
// verifies if value is a valid URL
export const verifyUrl = (value) => {
  try {
    new URL(value)
    return true
  } catch (_) {
    return false
  }
}

// generate select option from an array of object containing id/name key
export const generateOptions = (dataArray, labelKey = 'name', valueKey = 'id') => {
  return dataArray
    ? dataArray.map((d) => ({
        label: d[labelKey],
        ...d,
      }))
    : ''
}
export const generateOptionsFromStringArray = (dataArray) => {
  return dataArray
    ? dataArray.map((d) => ({
        label: d,
        value: d,
      }))
    : ''
}

export const jsonPP = (jsonObj) => {
  return process.env.NODE_ENV === 'development' && process.env.REACT_APP_CONSOLE_LOG === 'enable' ? <pre>{JSON.stringify(jsonObj, null, 3)}</pre> : ''
}

export const getOSInfo = () => ({
  arch: os.arch(),
  cpus: os.cpus(),
  freemem: os.freemem(),
  toltalmem: os.totalmem(),
  homedir: os.homedir(),
  hostname: os.hostname(),
  platform: os.platform(),
  release: os.release(),
  uptime: os.uptime(),
  // userInfo: os.userInfo()
})

export const titleCase = (str) => {
  return startCase(toLower(str))
  // if (isEmpty(str)) return str
  // var splitStr = str.toLowerCase().split(' ')
  // for (var i = 0; i < splitStr.length; i++) {
  //   splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  // }
  // return splitStr.join(' ')
}
export const howLong = (date) => moment(date).fromNow()
export const utcTime = (date) => moment(date).format('LLL')
export const localTime = (date) => moment.utc(date).local().format('LLL')
export const mdy = (date) => moment(date).format('ll')
export const ymd = (date) => moment(date).format('YYYY-MM-DD')
export const dayDiff = (start, end) => moment.duration(moment(end).diff(moment(start), 'days')).asDays()
export const reactTableFilterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id
  //console.log(row._original[id].map(d => d.name).join().toLowerCase().includes(filter.value.toLowerCase()))
  //return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : false
  switch (typeof row[id]) {
    case 'undefined':
      return false
    case 'object':
      if (row[id].type === 'div') {
        // console.log({ id, r: row._original })
        return row._original[id].toLowerCase().includes(filter.value.toLowerCase())
      } else {
        return row._original[id]
          .map((d) => d.name)
          .join()
          .toLowerCase()
          .includes(filter.value.toLowerCase())
      }
    default:
      return String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
  }
}
export const reactTableRowCustomization = (state, rowInfo) => {
  return rowInfo
    ? {
        style: {
          background: rowInfo.index % 2 === 0 ? '#e0e0e0' : '#ffffff',
          color: 'black',
          padding: '1px',
          margin: '0px',
          // height: '39px',
          // overflow: 'hidden'
        },
      }
    : ''
}
export const isMissingSigner = (application) => {
  const { signers, lastLevelToSign } = application
  /*
    the 2nd parameter of slice is the number for elements to cut out, negative number means from the end to count,
    so if lastLevelToSign is a negative number, it actually always includes all the elements to test
  */
  return isEmpty(signers) || signers.slice(0, lastLevelToSign).reduce((assumeFalse, signer) => assumeFalse || isEmpty(signer.id), false)
}
// do NOT use creator.id in the following, for new application, the creator may not have been populated yet.
// isEmpty will NOT puke on undefined if use like application.id, but if you deconstructing and ref to id, it will puck since id is undefined and not referable
// export const isShowSaveButton = (application, userId) => {
//   if (isEmpty(application)) return false
//   const { id = '', activeStep, creatorId } = application
//   return isEmpty(id) || (activeStep === -1 && creatorId === userId)
// }
export const isShowSaveButton = (application, userId, originalHash) => {
  if (isEmpty(application)) return false
  const {  creatorId } = application
  logger(`[utility][isShowSaveButton]:`, { application, originalHash, hash: hash(application), creatorId, userId })
  return originalHash !== hash(application) && (isEmpty(creatorId) || creatorId === userId)
}
export const isShowSubmitButton = (application, userId, isHRAdmin = false) => {
  /*
      1. empty application data
      2. application does not have an id
      3. application's status is draft
  */
  if (isEmpty(application)) return false
  try {
    const { id = '', type,  creatorId, lastLevelToSign, status } = application
    // 1) 有id
    // 2) activeStep 等于 -1 或者 lastLevelToSign 等于-1, 证明还没有提交过 ， 这个要查， isMissingSigner再数组为空（初始时候）会报告 false - 这样submit 按钮条件也会成立
    // 3） amount 没有超过边界, 这个就不要检查了，输入validation应该足够了
    // 4） 当前用户拥有 这个 application
    // 5） 所有signer可以找到

    //return !isEmpty(id) && activeStep === -1 && lastLevelToSign > 0 && creatorId === userId && !isMissingSigner(application)
    if (type.id === 0) {
      return ((!isEmpty(id) && status === 'draft') || isEmpty(id)) && creatorId === userId && lastLevelToSign > -1 && !isMissingSigner(application)
    } else {
      return !isEmpty(id) && status === 'draft' && (creatorId === userId || isHRAdmin) && lastLevelToSign > -1 && !isMissingSigner(application)
    }
  } catch (e) {
    logger('Application: isShowSubmitButton', e.message, true)
  }
}

export const isShowActionButtons = (application, userId) => {
  logger(`[utility][isShowActionButtons]:`, { application, userId })
  if (isEmpty(application)) return false
  const { status, signers, activeStep } = application
  // try catch doesn't work, use if to list all possible exceptions
  // try catch should have worked, the error of id of null should araised in general main page
  if (activeStep < 0 || isEmpty(signers) || isEmpty(signers[activeStep])) {
    return false
  } else {
    return status === 'submitted' && signers[activeStep].id === userId
  }
}

export const isShowPrintButton = (application, userId, originalHash) => {
  const { status } = application
  // console.log([('rejected', 'completed', 'submitted')].includes(status))
  return !isShowActionButtons(application, userId, originalHash) || [('rejected', 'completed', 'submitted')].includes(status)
}
export const isShowArchivedButton = (application, userRole) => {
  logger(`[utility][isShowArchivedButton]:`, { application, userRole })
  if (isEmpty(application)) return false
  const { status, expenseOrProcurement, archived } = application
  return status === 'completed' && isEmpty(archived.by) && userRole === expenseOrProcurement
}
export const statusNotAllowToBeModified = ['submitted', 'completed', 'rejected']

export const objectHash = (data) => {
  // console.log(jsonPP(data))
  return hash(data)
}

export const getCurrentExchangeRate = (from, to) => getCurrencyRate(from, to)

export const getSingerTitle = (signer, key, signingPath) => {
  if (!isEmpty(signer.position)) return signer.position
  if (!isEmpty(signer.approverGroupName)) return signer.approverGroupName
  if (signingPath && signingPath.levels[key]) {
    if (signingPath.levels[key].approverType === '1') {
      return 'Manager of Prev Level'
    } else {
      return signingPath.levels[key].approverGroupName
    }
  }
  return ''
}
